import { RootState } from 'store';
import { IOtherReceiptsResponse } from 'types';

export const getOtherReceiptsListSelector = (store: RootState): IOtherReceiptsResponse | null =>
	store.otherReceipts.otherReceiptsList || null;

export const getOtherReceiptsListIsLoadingSelector = (store: RootState): boolean => store.otherReceipts.isLoading;
